module.exports = __webpack_public_path__ + "assets/images/amira_growth_default.60d89418ed49f4f5bdbbd711f8521c98.svg";